/**
 * Converts an object into URLSearchParams format.
 */
export const objectToSearchParams = (
  object: Record<string, string | number | Array<string | number>>
) => {
  const query = Object.entries(object)
    .reduce((search, [key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(valueEntry => {
          search.append(`${key}[]`, valueEntry.toString());
        });
      } else {
        search.set(key, value.toString());
      }

      return search;
    }, new URLSearchParams())
    .toString();

  if (query.length > 0) {
    return `?${query}`;
  }
  return '';
};
